import {
    Row,
    Col,
    Accordion,
    Card,
    OutlineButton,
    PrimaryButton,
    InputField,
    Breadcrumb,
    EventHandler,
} from "../../../../CommonComponents";
import LeaderOrder from "./LeadrOrder";
import Pending from "../../../../assets/images/Myorder_Pending Approval.png";
import "./AssetApproval.scss";
import Moment from "moment";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";
import AssetInformation from "./LeadrOrder/AssetInformation";
import PopupDialogbox from "./PopupDilalogBox/PopupDilalogBox";
import AssetDispositionAndLocation from '../AssetDispositionAndLocation'
import ReceivingBranchDetails from "../ReceivingBranchDetails";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import ApprovalHistoryTimeLineCommon from "client/CommonComponents/ApprovalHistoryTimeLineCommon";

const AssetApproval = (props: any) => {
  const transferOrderByIdData = props?.transferOrderByIdData;
  const transferApprovalRequestOption = props?.transferApprovalRequestOption
  let Comment = props.comment;
  let createdRequestTypeVal = props?.createdRequestTypeVal;
  let isOverrideActionapplicable = props?.isOverrideActionapplicable;
  let WarningPopupcontent=props?.WarningPopupcontent
  let warningHideDialog=props?.warningHideDialog
  const requesttype = props?.requesttype;

  const ExpandedItems = [
    {
      headerText: (
        <div className="accordionHeader">
          <div className="accordionHeaderLeft mt-0">
            <p className="accord-heading assetpendingapproval">
              LEADR ORDER# - {transferOrderByIdData?.orderId}
            </p>
          </div>        
          <div className="accordionHeaderRight">
          {isOverrideActionapplicable && 
          <span className="Admin-view">
            SUPER ADMIN VIEW
            </span>}
          <div className="orderRequestType">
              <label className="labelText">Request Type</label>
              <span className="requestTypeText">
               {createdRequestTypeVal()}
              </span>
            </div>
            <div>
              {requesttype === CONSTANTS.AFEREQUEST ? (
                <>
                  <label className="labelText">AFE Type</label>
                  <span className="frsOrderText">
                    {transferOrderByIdData?.afeDetail?.afeType || '-'}
                  </span>
                </>
              ) : (
                <>
                  <label className="labelText">FRS Order #</label>
                  <span className="frsOrderText">
                    {transferOrderByIdData?.frsOrderNumber || '-'}
                  </span>
                </>
              )}
            </div>
            <div>
              <label className="labelText">Created Date</label>
              <span className="dateContent">
                {transferOrderByIdData?.createdDate
                  ? Moment(transferOrderByIdData?.createdDate).format(
                    "MM/DD/YYYY"
                  )
                  : ""}
              </span>
            </div>
            <div>
              <label className="labelText">Updated Date</label>
              <span className="dateContent">
                {transferOrderByIdData?.updatedDate
                  ? Moment(transferOrderByIdData?.updatedDate).format(
                    "MM/DD/YYYY"
                  )
                  : ""}
              </span>
            </div>
          </div>
        </div>
      ),
      content: <LeaderOrder />,
      uuid: "Accordion1",
    }
  ];

    const returnOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {transferOrderByIdData?.orderId}
            </p>
            <p>Order has been return to requestor successfully</p>
        </>
    );

    const rejectOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {transferOrderByIdData?.orderId}
            </p>
            <p>Order has been rejected</p>
        </>
    );
    const approveOrderconfirmation = (
        <>
            <p>
                <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {transferOrderByIdData?.orderId}
            </p>
            {
                transferOrderByIdData?.assets?.map((item: any, index: any) => {
                    return (
                        <>
                            <p>{item?.subOrderType}</p>
                        </>
                    )
                })
            }
        </>
    );

    const returnOrdersubtext = (
        <>
            <p>
                Please provide a comment before returning order request to the requestor
            </p>
        </>
    );
    const rejectOrdersubtext = (
        <>
            <p>Please provide a comment before rejecting order</p>
        </>
    );
    const approveOrdersubtext = (
        <>
            <p>Are you sure you want to approve this order?</p>
        </>
    );
    const submitOrdersubtextFunction = (
        <>
            <p>Are you sure you want to submit this approval?</p>
        </>
    )
    const cancelOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Approval</p>
            <p>{CONSTANTS.LEADR_ORDER_NUMBER}</p>
            <p>{transferOrderByIdData?.orderId}</p>
        </>
    );
    const cancelActualOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Order</p>
            <p>
                <b>LEADR Order # : </b>{transferOrderByIdData?.orderId}
            </p>
        </>
    );
    const errorMessage = (
        <>
            <p>Please enter comments below 500 characters</p>
        </>
    );

    return (
        <>
            <div className="pendingApproval assetPendingApproval mt-md-0" ref={props.wrapperRef}>
                <div className="clearfix breadCrumbBlock">
                    {/* {
            props.mobile ?
              <div className='backIcon' onClick={props.handleClickBack}>
                <img src={arrowIcon} alt='back Btn' />
              </div> :  */}
                    <EventHandler onEvent={props.handleClickBack} data-attribute="AssetApproval_Default_EventHandler">
                        <div className='backButton mb-sm-2 mb-3'>
                            <span className="fa fa-chevron-left"></span>
                            Back
                        </div>
                    </EventHandler>
                    {/* } */}
                    <div className="breadcrumbList">
                        <Breadcrumb items={props?.breadcrumlist} maxDisplayedItems="5"  data-attribute="AssetApproval_Default_Breadcrumb" />
                    </div>
                    <div className="float-right">
                        <div className="pending">
                            <img
                                src={Pending}
                                alt="Pending Approval"
                                title="Pending Appproval"
                                className="me-2"
                            />
                            <span className="pending-approval-text">Pending Approval</span>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col xs={12} lg={8}>
                        <Card data-attribute="AssetApproval_Default_Card">
                            <Accordion
                                Items={ExpandedItems}
                                preExpanded={["Accordion1"]}
                                className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
                             data-attribute="AssetApproval_Default_Accordion" />
                            {transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any, detailsByIdIndex: number) => {
                                if (detailsByIdItem?.orderRequestType !== CONSTANTS?.TRANSFER_REQUEST) {
                                    return detailsByIdItem?.assets?.map((assetOrderByIdItem: any, assetOrderByIdIndex: number) => {
                                        return (
                                            <>
                                                <div className="blueLabel">Asset Information</div>
                                                <AssetInformation assetOrderByIdItem={assetOrderByIdItem} assetOrderByIdIndex={assetOrderByIdIndex} detailsByIdIndex={detailsByIdIndex} detailsByIdItem={detailsByIdItem} />
                                            </>
                                        )
                                    })
                                } else if (detailsByIdItem?.orderRequestType === CONSTANTS?.TRANSFER_REQUEST) {
                                    return <ReceivingBranchDetails
                                        detailsByIdItem={detailsByIdItem}
                                        detailsByIdIndex={detailsByIdIndex}
                                        orderDetails={transferOrderByIdData}
                                        viewtype="approval-view"
                                        key={detailsByIdItem?.requestIndex}
                                    />
                                }
                            })}

              <div>
              {transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any, detailsByIdIndex: number) => {
                if(detailsByIdItem?.orderRequestType == CONSTANTS?.DISPOSITION_REQUEST){
                return <AssetDispositionAndLocation detailsByIdItem = {detailsByIdItem} viewtype="approval-view" />
                }
              })}
              {requesttype === CONSTANTS.AFEREQUEST &&
              <AssetInformation requesttype = {requesttype}/>}
              
                <p className="blueLabel mt-0">Approver Comments</p>
                <InputField
                  multiline
                  resizable={false}
                  row={4}
                  value={props.comment}
                  onChange={props.onChangeComment}
                 data-attribute="AssetApproval_Default_Input" />
                {props.commentError === true ? (
                  <span className="asset-validation-msg text-danger">{errorMessage}</span>
                ) : null}
              </div>
              <div className="clearfix orderBtn">
                {!transferApprovalRequestOption?.length ? (
                  <div className="btnBlock">
                    {props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN) && (
                    <OutlineButton
                        disabled={!props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)}
                        text='Cancel Order'
                        onClick={() => props.cancelActualOrderReq(cancelActualOrdersubtext)}
                        title={(props.getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ? "Cancel Order" : ACCESS_DENIED}
                     data-attribute="AssetApproval_Default_Button" /> )}
                    <OutlineButton
                      text="Return Order to Requestor"
                      onClick={() =>
                        props?.returnOrderReq(returnOrdersubtext, Comment)
                      }
                      disabled={!isAuthorized(permissions.ApprovalsReturnToRequestor)}
                      title={isAuthorized(permissions.ApprovalsReturnToRequestor) ? "Return Order to Requestor" : ACCESS_DENIED}
                     data-attribute="AssetApproval_Default_Button_2" />
                    <OutlineButton
                      text="Reject Order"
                      onClick={() =>
                        props?.rejectOrderReq(rejectOrdersubtext, Comment)
                      }
                      disabled={!isAuthorized(permissions.ApprovalsReject)}
                      title={isAuthorized(permissions.ApprovalsReject) ? "Reject Order" : ACCESS_DENIED}
                     data-attribute="AssetApproval_Default_Button_3" />
                    <PrimaryButton
                      text="Approve Order"
                      onClick={() =>
                        props?.approveOrderReq(approveOrdersubtext, Comment)
                      }
                      disabled={props.disableApproveOrder() || !isAuthorized(permissions.ApprovalsApprove)}
                      title={isAuthorized(permissions.ApprovalsApprove) ? "Approve Order" : ACCESS_DENIED}
                     data-attribute="AssetApproval_Default_Button_4" />
                  </div>
                ) : (
                  <div className="btnBlock">
                    <OutlineButton
                      text="Cancel"
                      onClick={() => props?.cancelOrderReq(cancelOrdersubtext)}
                     data-attribute="AssetApproval_Default_Button_5" />
                    <PrimaryButton
                      text="Submit Approval"
                      onClick={() => props?.submitOrderReq(submitOrdersubtextFunction)}
                      disabled={props.disableSubmitOrder()}
                     data-attribute="AssetApproval_Default_Button_6" />
                  </div>
                )}
              </div>
              <PopupDialogbox
                requestOption={transferApprovalRequestOption}
                hideDialog={!props?.Popupcontent.isDialogVisible}
                onDismiss={props?.hideDialog}
                Popupcontent={props?.Popupcontent}
                popupOutlinebtnOnclick={props?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={(
                  item: any,
                  _comments: string,
                  actionby: string,
                  value: any
                ) => {
                  props?.popupPrimarybtnOnclick(
                    item,
                    (_comments || props.comment),
                    actionby,
                    value,
                    returnOrderconfirmation,
                    rejectOrderconfirmation,
                    approveOrderconfirmation
                  );
                }}
                orderDetails={transferOrderByIdData}
               data-attribute="AssetApproval_Default_PopupDilalogBox" />
              {WarningPopupcontent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!WarningPopupcontent.isDialogVisible}
                    onDismiss={warningHideDialog}
                    Popupcontent={WarningPopupcontent}
                    popupOutlinebtnOnclick={() => WarningPopupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => WarningPopupcontent.popupPrimarybtnOnclick()}
                    className='penalty-warning-popup'
                /> : ""}
            </Card>
          </Col>
          <Col xs={12} lg={4} className="BudgetCard">
            <ApprovalHistoryTimeLineCommon isOrderDetail = {false} approvalHistory = {transferOrderByIdData?.approvalHistory} data-attribute="AssetApproval_Default_ApprovalHistoryTimeLineCommon" />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default AssetApproval